window.teyraT = (k, d, v) => {
  let s = (window.TEYRA_I18N && window.TEYRA_I18N[k]) || d;
  /* Shopify's t filter HTML-escapes (& -> &amp;); decode so esc() later doesn't double-escape */
  if (typeof s === 'string' && s.indexOf('&') > -1) { const ta = document.createElement('textarea'); ta.innerHTML = s; s = ta.value; }
  if (v) Object.keys(v).forEach(n => { s = s.split('{' + n + '}').join(v[n]); });
  return s;
};
window.teyraRoot = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
(() => {
  const T = window.teyraT;
  const setCategory = (form, raw) => {
    const sel = form.elements.category; if (!sel || !raw) return;
    const map = {'Cliniques dentaires et médicales':'Dental & Medical','Restaurants et cafés':'Restaurants & Cafés','Dental & Medical Clinics':'Dental & Medical','Restaurants & Cafés':'Restaurants & Cafés','Beauty & Wellness':'Beauty & Wellness','Luxury & Hospitality':'Luxury & Hospitality','E-commerce & Retail':'E-commerce & Retail','Other Projects':'Other'};
    const key = map[raw] || raw;
    const opt = Array.from(sel.options).find(o => o.dataset.key === key || o.textContent.trim() === raw || o.value === raw);
    if (opt) sel.value = opt.value;
  };
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const header = document.querySelector('[data-site-header]');
  const nav = document.querySelector('[data-main-nav]');
  const toggle = document.querySelector('[data-menu-toggle]');
  const updateHeader = () => { if (header) header.classList.toggle('is-scrolled', window.scrollY > 14); };
  updateHeader(); window.addEventListener('scroll', updateHeader, { passive: true });
  const cinematicHero = document.querySelector('[data-cinematic-home]');
  const cinematicStory = document.querySelector('[data-cinematic-reveal]');
  if (cinematicStory) {
    if ('IntersectionObserver' in window && !reduceMotion) {
      const storyObserver = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('is-in-view'); storyObserver.unobserve(entry.target); }
      }), { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
      storyObserver.observe(cinematicStory);
    } else cinematicStory.classList.add('is-in-view');
  }
  if (cinematicHero && !reduceMotion) {
    let cinematicRaf = 0;
    const updateCinematicDepth = () => {
      const rect = cinematicHero.getBoundingClientRect();
      const progress = Math.max(0, Math.min(1, -rect.top / Math.max(1, rect.height)));
      cinematicHero.style.setProperty('--hero-scroll-shift', `${progress * 30}px`);
      cinematicHero.style.setProperty('--hero-copy-shift', `${progress * -13}px`);
      cinematicRaf = 0;
    };
    const requestCinematicDepth = () => { if (!cinematicRaf) cinematicRaf = window.requestAnimationFrame(updateCinematicDepth); };
    updateCinematicDepth();
    window.addEventListener('scroll', requestCinematicDepth, { passive: true });
    window.addEventListener('resize', requestCinematicDepth, { passive: true });
  }
  if (toggle && nav) {
    const closeMenu = () => {
      toggle.setAttribute('aria-expanded', 'false');
      nav.classList.remove('is-open');
      document.body.style.overflow = '';
    };
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(open));
      nav.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    });
    nav.querySelectorAll('a').forEach(a => a.addEventListener('click', closeMenu));
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') closeMenu();
    });
  }
  const revealItems = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && !reduceMotion) {
    const observer = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } }), { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    revealItems.forEach((item, i) => { item.style.transitionDelay = `${Math.min(i % 4, 3) * 65}ms`; observer.observe(item); });
  } else revealItems.forEach(item => item.classList.add('is-visible'));
  document.querySelectorAll('[data-hero-gallery]').forEach(gallery => {
    const feature = gallery.querySelector('[data-hero-feature-image]');
    const category = gallery.querySelector('[data-hero-image-label]');
    const caption = gallery.querySelector('[data-hero-caption]');
    const imageIndex = gallery.querySelector('[data-hero-image-index]');
    const selectors = Array.from(gallery.querySelectorAll('[data-hero-select]'));
    if (!feature || selectors.length < 2) return;
    selectors.forEach((button, index) => {
      button.addEventListener('click', () => {
        const nextSrc = button.dataset.heroImage;
        if (!nextSrc) return;
        const applySelection = () => {
          feature.src = nextSrc;
          feature.alt = button.dataset.heroAlt || 'Selected TEYRA Studio website design';
          if (category) category.textContent = button.dataset.heroCategory || '';
          if (caption) caption.textContent = button.dataset.heroCaption || '';
          if (imageIndex) imageIndex.textContent = `${String(index + 1).padStart(2, '0')} / ${String(selectors.length).padStart(2, '0')}`;
          selectors.forEach(item => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          feature.classList.remove('is-switching');
        };
        if (reduceMotion) {
          applySelection();
        } else {
          feature.classList.add('is-switching');
          window.setTimeout(applySelection, 140);
        }
      });
    });
  });
  const hero = document.querySelector('[data-motion-hero]');
  if (hero && !reduceMotion && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    const cards = hero.querySelectorAll('[data-parallax]');
    let raf = 0; let px = 0; let py = 0;
    hero.addEventListener('pointermove', e => { const r = hero.getBoundingClientRect(); px = (e.clientX - r.left) / r.width - .5; py = (e.clientY - r.top) / r.height - .5; if (!raf) raf = requestAnimationFrame(() => { cards.forEach(card => { const depth = Number(card.dataset.parallax || 1); card.style.translate = `${px * 14 * depth}px ${py * 12 * depth}px`; }); raf = 0; }); });
    hero.addEventListener('pointerleave', () => cards.forEach(card => { card.style.translate = '0 0'; }));
  }
  document.querySelectorAll('[data-selected-work-carousel]').forEach(carousel => {
    const track = carousel.querySelector('[data-selected-work-track]');
    const previous = carousel.querySelector('[data-work-prev]');
    const next = carousel.querySelector('[data-work-next]');
    if (!track) return;
    const scrollAmount = () => Math.max(260, track.clientWidth * 0.78);
    previous?.addEventListener('click', () => track.scrollBy({ left: -scrollAmount(), behavior: reduceMotion ? 'auto' : 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: scrollAmount(), behavior: reduceMotion ? 'auto' : 'smooth' }));
    // Counter + progress bar for the showcase cards
    const cards = Array.from(track.querySelectorAll('.selected-work-card'));
    const controls = carousel.querySelector('.selected-work-controls');
    if (cards.length > 1 && controls) {
      const pad = n => String(n).padStart(2, '0');
      const count = document.createElement('span');
      count.className = 'selected-work-count';
      count.setAttribute('aria-hidden', 'true');
      controls.insertBefore(count, next);
      const bar = document.createElement('div');
      bar.className = 'selected-work-progress';
      bar.setAttribute('aria-hidden', 'true');
      bar.innerHTML = '<i></i>';
      track.insertAdjacentElement('afterend', bar);
      const fill = bar.firstChild;
      const sync = () => {
        const max = Math.max(1, track.scrollWidth - track.clientWidth);
        const ratio = Math.min(1, Math.max(0, track.scrollLeft / max));
        const first = cards[0].getBoundingClientRect().left;
        const step = cards.length > 1 ? cards[1].getBoundingClientRect().left - first : 1;
        const trackLeft = track.getBoundingClientRect().left;
        const idx = Math.min(cards.length, Math.max(1, Math.round((trackLeft - first) / (step || 1)) + 1));
        count.innerHTML = `<b>${pad(ratio > 0.985 ? cards.length : idx)}</b> / ${pad(cards.length)}`;
        const w = Math.max(8, 100 / cards.length);
        fill.style.width = w + '%';
        fill.style.transform = `translateX(${ratio * (100 / w - 1) * 100}%)`;
      };
      let raf = 0;
      track.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(() => { raf = 0; sync(); }); }, { passive: true });
      window.addEventListener('resize', sync, { passive: true });
      sync();
    }
  });
  document.querySelectorAll('[data-project-gallery]').forEach(gallery => {
    const mainImage = gallery.querySelector('[data-gallery-main]');
    const counter = gallery.querySelector('[data-gallery-counter]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    if (!mainImage || thumbs.length < 2) return;
    thumbs.forEach((button, index) => {
      button.addEventListener('click', () => {
        const src = button.dataset.gallerySrc;
        if (!src) return;
        mainImage.src = src;
        mainImage.alt = T('img_alt', '{title} — project image {n}', {title: document.title, n: index + 1});
        if (counter) counter.textContent = `${String(index + 1).padStart(2, '0')} / ${String(thumbs.length).padStart(2, '0')}`;
        thumbs.forEach(thumb => {
          const active = thumb === button;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      });
    });
  });

  // Dedicated standalone case-study view. Keep the shared header and footer,
  // but replace all page content so homepage sections never appear on project pages.
  (() => {
    const params = new URLSearchParams(window.location.search);
    const projectSlug = params.get('project');
    if (!projectSlug) return;

    const main = document.querySelector('#MainContent');
    const portfolio = document.querySelector('.portfolio-section');
    if (!main || !portfolio) return;

    const card = Array.from(portfolio.querySelectorAll('[data-project-card]'))
      .find(item => item.dataset.projectSlug === projectSlug);
    if (!card) return;

    const esc = value => String(value || '').replace(/[&<>"']/g, char => ({
      '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;'
    }[char]));
    const d = card.dataset;
    const cfg = window.TEYRA_CFG || {};
    // "8000 MAD" -> "8 000 MAD" (keeps any other format untouched)
    const fmtPrice = raw => {
      const m = String(raw || '').trim().match(/^(\d[\d\s.,]*)(.*)$/);
      if (!m) return String(raw || '');
      const n = Number(m[1].replace(/[\s,.]/g, ''));
      return Number.isFinite(n) && n > 0 ? `${n.toLocaleString('fr-FR').replace(/[\u202f\u00a0]/g, '\u00a0')}${m[2] ? '\u00a0' + m[2].trim() : ''}` : String(raw);
    };
    const priceText = d.projectPrice ? fmtPrice(d.projectPrice) : '';
    const highlightItems = String(d.projectFeatures || '').split(/\s*,\s*/).map(x => x.trim()).filter(Boolean);
    const waNumber = String(cfg.whatsapp || '').replace(/\D/g, '');
    const waUrl = waNumber ? `https://wa.me/${waNumber}?text=${encodeURIComponent(T('wa_msg', 'Hello TEYRA STUDIO, I’m interested in the website “{title}”.', {title: d.projectTitle}))}` : '';
    const root = (location.origin + (window.teyraRoot() || '/')).replace(/\/$/, '') + '/';
    const here = Array.from(portfolio.querySelectorAll('[data-project-card]'));
    const related = here.filter(c => c !== card && c.dataset.projectSlug)
      .sort((a, b) => (b.dataset.projectCategory === d.projectCategory) - (a.dataset.projectCategory === d.projectCategory))
      .slice(0, 3);
    const projectUrl = c => `${window.location.pathname}?view=${encodeURIComponent(params.get('view') || 'portfolio')}&project=${encodeURIComponent(c.dataset.projectSlug)}`;
    const relatedHtml = related.length ? `<section class="project-related" aria-label="${esc(T('related', 'More projects'))}">
        <p class="eyebrow">${esc(T('related', 'More projects'))}</p>
        <div class="project-related-grid">${related.map(c => `<a class="project-related-card" href="${esc(projectUrl(c))}">
          <span class="project-related-media"><img src="${esc(c.dataset.projectImage)}" alt="" loading="lazy"></span>
          <span class="project-related-body"><small>${esc(c.dataset.projectCategory)}</small><strong>${esc(c.dataset.projectTitle)}</strong><em>${esc(T('view_project', 'View project'))} ↗︎</em></span></a>`).join('')}</div>
      </section>` : '';
    const HL_VISIBLE = 4;
    const highlightsHtml = highlightItems.length ? `<h2>${esc(T('highlights', 'Key highlights'))}</h2><ul class="project-highlights-grid" data-highlights>${highlightItems.map((x, i) => `<li${i >= HL_VISIBLE ? ' class="is-extra"' : ''}><span class="project-highlight-num">${String(i + 1).padStart(2, '0')}</span><span>${esc(x)}</span></li>`).join('')}</ul>${highlightItems.length > HL_VISIBLE ? `<button class="project-highlights-toggle" type="button" data-highlights-toggle aria-expanded="false">${esc(T('hl_more', 'Show all {n} highlights', {n: highlightItems.length}))}</button>` : ''}` : '';
    const infoTpl = card.querySelector('template[data-project-info]');
    const infoHtml = infoTpl ? infoTpl.innerHTML.trim() : '';
    const embeddedImages = Array.from(card.querySelectorAll('[data-gallery-source]')).map(node => node.dataset.gallerySource).filter(Boolean);
    const images = Array.from(new Set((embeddedImages.length ? embeddedImages : [d.projectImage, d.projectImage2, d.projectImage3, d.projectImage4, d.projectImage5, d.projectImage6, d.projectImage7]).filter(Boolean)));
    const altFor = n => T('gal_alt', '{title} — website design preview {n} of {total}', {title: d.projectTitle, n, total: images.length});
    const gallery = images.length
      ? `<div class="project-gallery-viewer">
          <div class="project-gallery-stage">
            <img class="project-gallery-main-image" src="${esc(images[0])}" alt="${esc(altFor(1))}" fetchpriority="high" decoding="async">
            <span class="project-gallery-counter">01 / ${String(images.length).padStart(2, '0')}</span>
          </div>
          ${images.length > 1 ? `<div class="project-gallery-thumbnails" aria-label="${esc(T('gallery_aria', 'Project image gallery'))}">${images.map((src, i) =>
            `<button class="project-gallery-thumb${i === 0 ? ' is-active' : ''}" type="button" data-gallery-thumb="${i}" aria-label="${esc(T('show_img', 'Show project image {n}', {n: i + 1}))}" aria-pressed="${i === 0 ? 'true' : 'false'}"><img src="${esc(src)}" alt="" loading="lazy"><span>${String(i + 1).padStart(2, '0')}</span></button>`
          ).join('')}</div>` : ``}
        </div>`
      : `<div class="project-gallery-empty"><p>${esc(T('images_soon', 'Project images will be added soon.'))}</p></div>`;

    const videoTpl = card.querySelector('template[data-project-video]');
    const videoHtml = videoTpl ? videoTpl.innerHTML.trim() : '';

    const demo = d.projectDemo
      ? `<a class="button button-dark project-live-demo-button" href="${esc(d.projectDemo)}" target="_blank" rel="noopener">${esc(T('live_demo', 'View live demo'))} <span aria-hidden="true">↗︎</span></a>`
      : `<button class="button button-dark project-live-demo-button" type="button" data-demo-missing>${esc(T('live_demo', 'View live demo'))} <span aria-hidden="true">↗︎</span></button><p class="project-demo-note">${esc(T('demo_missing_note', 'The live demo link will appear here once it has been connected.'))}</p>`;
    const password = `<div class="demo-access-box${d.projectDemoPassword ? '' : ' demo-access-placeholder'}">
          <div class="demo-access-heading"><span class="demo-access-kicker">${esc(T('demo_kicker', 'PRIVATE DEMO ACCESS'))}</span><span class="demo-access-lock" aria-hidden="true">⌑</span></div>
          <p class="demo-access-help">${d.projectDemoPassword ? esc(T('demo_help_set', 'Shopify may ask for a storefront password. Use the access code below.')) : esc(T('demo_help_missing', 'The demo password will appear here after it is added in the project settings.'))}</p>
          <div class="demo-password-row"><input class="demo-password-input" type="text" value="${esc(d.projectDemoPassword || '')}" readonly aria-label="${esc(T('demo_pw_aria', 'Demo storefront password'))}" placeholder="${esc(T('demo_pw_ph', 'Demo password not added yet'))}"><button class="button button-outline demo-copy-password" type="button">${esc(T('copy_code', 'Copy code'))}</button></div>
          <span class="demo-copy-status" aria-live="polite"></span>
        </div>`;

    const startProjectUrl = `${window.location.origin}${window.teyraRoot()}pages/start-project`;
    const requestUrl = (type) => `${startProjectUrl}?project=${encodeURIComponent(d.projectSlug)}&project_title=${encodeURIComponent(d.projectTitle)}&category=${encodeURIComponent(d.projectCategory)}&request_type=${encodeURIComponent(type)}${d.projectPrice ? `&project_price=${encodeURIComponent(d.projectPrice)}` : ''}#contact`;
    const view = document.createElement('section');
    view.className = 'project-case-study section-pad';
    view.setAttribute('aria-labelledby', 'project-case-title');
    view.innerHTML = `<div class="wrap">
      <a class="project-back" href="${esc(window.location.pathname + (params.get('view') ? '?view=' + encodeURIComponent(params.get('view')) : ''))}">← ${esc(T('back_all', 'Back to all projects'))}</a>
      <header class="project-case-heading">
        <p class="eyebrow">${esc(d.projectCategory)} · TEYRA STUDIO</p>
        <h1 id="project-case-title">${esc(d.projectTitle)}</h1>
        <p class="project-case-tagline">${esc(d.projectTagline)}</p>
        <div class="project-demo-panel">
          ${demo}
          ${password}
        </div>
      </header>
      ${gallery}
      ${videoHtml}
      <div class="project-case-content">
        <article>
          <p class="eyebrow">${esc(T('overview', 'Project overview'))}</p>
          <p class="project-case-description">${esc(d.projectDescription)}</p>
          ${highlightsHtml}
        </article>
      </div>
      <section class="project-purchase-panel project-purchase-panel-top" data-purchase-panel aria-label="${esc(T('purchase_aria', 'Website purchase options'))}">
        <div class="project-purchase-summary">
          <p class="eyebrow">${esc(T('ready', 'Ready-made website'))}</p>
          ${d.projectPrice ? `<p class="project-ready-price"><strong>${esc(priceText)}</strong></p>` : `<p class="project-ready-price"><strong>${esc(T('price_request', 'Price available on request'))}</strong></p>`}
          <p class="project-purchase-intro">${esc(T('purchase_intro', 'Purchase this website as presented, or choose customization if you would like changes.'))}</p>
        </div>
        <div class="project-purchase-actions">
          <div class="project-action">
            <a class="button button-dark" href="${esc(requestUrl('purchase'))}">${esc(T('buy', 'Buy This Website'))} <span aria-hidden="true">↗︎</span></a>
            <p>${esc(T('buy_desc', 'For clients who want to proceed with this design.'))}</p>
          </div>
          <div class="project-action">
            <a class="button button-outline" href="${esc(requestUrl('customize'))}">${esc(T('customize', 'Customize This Design'))} <span aria-hidden="true">↗︎</span></a>
            <p>${esc(T('customize_desc', 'For clients who like this design direction but need a version tailored to their business or requirements.'))}</p>
          </div>
          <div class="project-action project-action--offer">
            <button class="button button-outline button-offer" type="button" data-offer-open data-offer-slug="${esc(d.projectSlug)}" data-offer-title="${esc(d.projectTitle)}" data-offer-price="${esc(d.projectPrice || '')}" data-offer-min="${esc(d.projectMinimumOffer || '')}" aria-haspopup="dialog">${esc(T('offer_btn', 'Make an Offer'))}</button>
            <p>${esc(T('offer_desc', 'Have a different budget in mind? Propose your price and let’s discuss it.'))}</p>
          </div>
        </div>
      </section>
      ${infoHtml}
      <section class="project-next" aria-labelledby="project-next-title">
        <div>
          <p class="eyebrow">${esc(T('next_kicker', 'Next step'))}</p>
          <h2 id="project-next-title">${esc(T('next_title', 'Prefer a version made for your business?'))}</h2>
          <p class="project-purchase-note">${esc(T('purchase_note', 'We’ll confirm your selection, final price and delivery details personally before payment.'))}</p>
        </div>
        <div class="project-next-actions">
          <a class="button button-outline" href="${esc(requestUrl('customize'))}">${esc(T('customize', 'Customize This Design'))} <span aria-hidden="true">↗︎</span></a>
          ${waUrl ? `<a class="button button-outline project-wa-button" href="${esc(waUrl)}" target="_blank" rel="noopener">${esc(T('wa_cta', 'Ask a question on WhatsApp'))} <span aria-hidden="true">↗︎</span></a>` : ''}
        </div>
      </section>
      ${relatedHtml}
    </div>`;

    main.replaceChildren(view);
    document.body.classList.add('is-project-detail');

    // Animate "What's included" / "How it works" when they scroll into view + soft cursor glow on cards.
    const groups = Array.from(view.querySelectorAll('[data-reveal-group]'));
    if ('IntersectionObserver' in window && !reduceMotion) {
      const gio = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); gio.unobserve(e.target); } }), { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
      groups.forEach(g => gio.observe(g));
    } else groups.forEach(g => g.classList.add('is-in'));
    view.querySelectorAll('.pi-card, .project-steps-list li').forEach(c => c.addEventListener('pointermove', ev => {
      const r = c.getBoundingClientRect();
      c.style.setProperty('--mx', (ev.clientX - r.left) + 'px');
      c.style.setProperty('--my', (ev.clientY - r.top) + 'px');
    }, { passive: true }));

    // Sticky purchase bar (mobile / tablet): price + buy button, hidden while the main purchase panel is on screen.
    const bar = document.createElement('div');
    bar.className = 'project-sticky-bar';
    bar.innerHTML = `<div class="project-sticky-price"><small>${esc(d.projectTitle)}</small><strong>${esc(priceText || T('price_request', 'Price available on request'))}</strong></div>
      <a class="button button-dark" href="${esc(requestUrl('purchase'))}">${esc(T('buy_short', 'Buy'))} <span aria-hidden="true">↗︎</span></a>`;
    document.body.appendChild(bar);
    const panel = view.querySelector('[data-purchase-panel]');
    const heading = view.querySelector('.project-case-heading');
    const state = {panel: false, top: true};
    const sync = () => bar.classList.toggle('is-visible', !state.panel && !state.top);
    if ('IntersectionObserver' in window) {
      if (panel) new IntersectionObserver(e => { state.panel = e[0].isIntersecting; sync(); }).observe(panel);
      if (heading) new IntersectionObserver(e => { state.top = e[0].isIntersecting; sync(); }, {threshold: 0.1}).observe(heading);
    }
    const hlToggle = view.querySelector('[data-highlights-toggle]');
    if (hlToggle) hlToggle.addEventListener('click', () => {
      const list = view.querySelector('[data-highlights]');
      const open = list.classList.toggle('is-open');
      hlToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      hlToggle.textContent = open ? T('hl_less', 'Show fewer') : T('hl_more', 'Show all {n} highlights', {n: highlightItems.length});
    });

    // Scroll-driven page tone: neutral dark -> deep violet while "What's included" is in view -> back to neutral at "More projects".
    (() => {
      const inc = view.querySelector('.project-included');
      const rel = view.querySelector('.project-related');
      if (!inc) return;
      const smooth = x => { x = Math.min(1, Math.max(0, x)); return x * x * (3 - 2 * x); };
      let raf = 0;
      const update = () => {
        raf = 0;
        const vh = window.innerHeight || 800;
        let tone = smooth((vh * 0.9 - inc.getBoundingClientRect().top) / (vh * 0.5));
        if (rel) tone *= 1 - smooth((vh * 1.0 - rel.getBoundingClientRect().top) / (vh * 0.45));
        if (reduceMotion) tone = tone > 0.5 ? 1 : 0;
        view.style.setProperty('--tone', tone.toFixed(3));
      };
      const queue = () => { if (!raf) raf = requestAnimationFrame(update); };
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue, { passive: true });
      update();
    })();

    document.title = `${d.projectTitle} — TEYRA STUDIO`;

    const galleryMain = view.querySelector('.project-gallery-main-image');
    const galleryCounter = view.querySelector('.project-gallery-counter');
    view.querySelectorAll('[data-gallery-thumb]').forEach(button => {
      button.addEventListener('click', () => {
        const index = Number(button.dataset.galleryThumb);
        if (!images[index] || !galleryMain) return;
        galleryMain.src = images[index];
        galleryMain.alt = altFor(index + 1);
        if (galleryCounter) galleryCounter.textContent = `${String(index + 1).padStart(2, '0')} / ${String(images.length).padStart(2, '0')}`;
        view.querySelectorAll('[data-gallery-thumb]').forEach(thumb => {
          const active = thumb === button;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      });
    });

    const missingDemoButton = view.querySelector('[data-demo-missing]');
    if (missingDemoButton) {
      missingDemoButton.addEventListener('click', () => {
        const note = view.querySelector('.project-demo-note');
        if (note) {
          note.textContent = T('demo_not_connected', 'This demo is not connected yet. Add the live demo URL in Shopify Theme Editor.');
          note.classList.add('is-visible');
        }
      });
    }

    const copyButton = view.querySelector('.demo-copy-password');
    if (copyButton) {
      copyButton.addEventListener('click', async () => {
        const input = view.querySelector('.demo-password-input');
        const status = view.querySelector('.demo-copy-status');
        if (!input.value.trim()) {
          status.textContent = T('pw_add_first', 'Add the demo password in Shopify Theme Editor first.');
          return;
        }
        try {
          await navigator.clipboard.writeText(input.value);
          status.textContent = T('pw_copied', 'Password copied.');
        } catch (_) {
          input.focus();
          input.select();
          const copied = document.execCommand('copy');
          status.textContent = copied ? T('pw_copied', 'Password copied.') : T('pw_select', 'Select and copy the password above.');
        }
      });
    }
  })();

  // Liquid-rendered project pages (sections/project-detail): reveal + soft glow for the shared project-info sections.
  if (!document.body.classList.contains('is-project-detail')) {
    const infoGroups = Array.from(document.querySelectorAll('.project-page [data-reveal-group]'));
    if (infoGroups.length) {
      if ('IntersectionObserver' in window && !reduceMotion) {
        const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
        infoGroups.forEach(g => io.observe(g));
      } else infoGroups.forEach(g => g.classList.add('is-in'));
      document.querySelectorAll('.project-page .pi-card, .project-page .project-steps-list li').forEach(c => c.addEventListener('pointermove', ev => {
        const r = c.getBoundingClientRect();
        c.style.setProperty('--mx', (ev.clientX - r.left) + 'px');
        c.style.setProperty('--my', (ev.clientY - r.top) + 'px');
      }, { passive: true }));
    }
  }

  document.querySelectorAll('[data-project-request]').forEach(button => button.addEventListener('click', () => {
    const form = document.querySelector('[data-inquiry-form]'); if (!form) return;
    form.elements.selected_project.value = button.dataset.projectRequest || '';
    setCategory(form, button.dataset.projectCategory || '');
    form.elements.requirements.value = T('req_similar', 'I’m interested in a website similar to: {name}. Please contact me to discuss the details.', {name: button.dataset.projectRequest || ''});
    form.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  }));
  document.querySelectorAll('[data-plan-request]').forEach(button => button.addEventListener('click', () => {
    const form = document.querySelector('[data-inquiry-form]'); if (!form) return;
    form.elements.selected_plan.value = button.dataset.planRequest || '';
    form.elements.requirements.value = T('req_plan', 'I would like to enquire about the {name} maintenance plan.', {name: button.dataset.planRequest});
    form.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  }));
  document.querySelectorAll('[data-service-request]').forEach(button => button.addEventListener('click', () => {
    const form = document.querySelector('[data-inquiry-form]'); if (!form) return;
    form.elements.selected_service.value = button.dataset.serviceRequest || '';
    form.elements.requirements.value = T('req_service', 'I would like to enquire about {name}.', {name: button.dataset.serviceRequest});
    form.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  }));
  document.querySelectorAll('[data-inquiry-form]').forEach(form => {
    const note = form.querySelector('[data-form-note]');
    const params = new URLSearchParams(window.location.search);
    const project = params.get('project_title') || params.get('project'); const plan = params.get('plan');
    const requestType = params.get('request_type') || '';
    if (project) {
      form.elements.selected_project.value = project;
      form.elements.requirements.value = requestType === 'purchase'
        ? T('req_purchase', 'I’d like to purchase the ready-made website: {name}. Please confirm the final price, what’s included, and the next steps.', {name: project})
        : T('req_customize', 'I’d like to customize this design: {name}. Please contact me to discuss the changes I need.', {name: project});
    }
    if (form.elements.request_type) form.elements.request_type.value = requestType;
    const selectedPrice = params.get('project_price') || '';
    if (form.elements.selected_project_price) form.elements.selected_project_price.value = selectedPrice;
    const summary = form.querySelector('[data-contact-project-summary]');
    if (summary && project) {
      summary.hidden = false;
      const typeLabel = requestType === 'purchase'
        ? T('summary_purchase', 'READY-MADE WEBSITE PURCHASE')
        : (requestType === 'customize' ? T('summary_customize', 'DESIGN CUSTOMIZATION REQUEST') : T('summary_project', 'PROJECT ENQUIRY'));
      const typeNode = summary.querySelector('[data-summary-type]');
      const titleNode = summary.querySelector('[data-summary-project]');
      const categoryNode = summary.querySelector('[data-summary-category]');
      const priceNode = summary.querySelector('[data-summary-price]');
      if (typeNode) typeNode.textContent = typeLabel;
      if (titleNode) titleNode.textContent = project;
      if (categoryNode) categoryNode.textContent = params.get('category') || '';
      if (priceNode) priceNode.textContent = selectedPrice ? `${T('summary_price', 'Displayed price')}: ${selectedPrice}${requestType === 'customize' ? ` · ${T('summary_custom_price', 'final customization quote to be confirmed')}` : ''}` : T('summary_price_request', 'Price available on request');
    }
    const budgetField = form.querySelector('[data-budget-field]');
    if (budgetField) {
      const isCustomRequest = requestType !== 'purchase';
      budgetField.hidden = !isCustomRequest;
      const budgetSelect = budgetField.querySelector('select');
      if (budgetSelect) budgetSelect.required = false;
    }
    const formHeading = form.closest('.contact-section')?.querySelector('.contact-copy h2');
    if (formHeading && requestType === 'purchase') formHeading.textContent = T('h_purchase', 'Request this ready-made website.');
    else if (formHeading && requestType === 'customize') formHeading.textContent = T('h_customize', 'Customize this design.');
    const requestedCategory = params.get('category'); if (requestedCategory) setCategory(form, requestedCategory);
    if (plan) { form.elements.selected_plan.value = plan; form.elements.requirements.value = T('req_plan', 'I would like to enquire about the {name} maintenance plan.', {name: plan}); }
    form.addEventListener('submit', e => {
      e.preventDefault();
      if (!form.reportValidity()) return;
      const root = form.closest('[data-whatsapp]'); const number = (root?.dataset.whatsapp || '').replace(/\D/g, '');
      if (!number) { if (note) { note.textContent = 'WhatsApp business number is not configured yet. Set it in Online Store → Themes → Customize → TEYRA Studio settings.'; note.classList.add('is-error'); } return; }
      const d = new FormData(form);
      const lines = [
        T('wa_hello', 'Hello TEYRA STUDIO 👋 — I would like to enquire about a project.'),
        '', `${T('wa_name', 'Full name')}: ${d.get('name')}`, `${T('wa_business', 'Business')}: ${d.get('business')}`, `${T('wa_email', 'Email')}: ${d.get('email')}`, `${T('wa_phone', 'My WhatsApp')}: ${d.get('phone')}`,
        `${T('wa_category', 'Category')}: ${d.get('category')}`,
        d.get('request_type') === 'purchase' ? T('wa_type_purchase', 'Request type: Purchase ready-made website') : (d.get('request_type') === 'customize' ? T('wa_type_customize', 'Request type: Customize this design') : ''),
        d.get('selected_project_price') ? `${T('wa_price', 'Displayed project price')}: ${d.get('selected_project_price')}` : '',
        d.get('budget') ? `${T('wa_budget', 'Estimated budget')}: ${d.get('budget')}` : '',
        `${T('wa_timeline', 'Desired timeline')}: ${d.get('timeline')}`,
        d.get('selected_project') ? `${T('wa_project', 'Reference project')}: ${d.get('selected_project')}` : '',
        d.get('selected_plan') ? `${T('wa_plan', 'Maintenance plan')}: ${d.get('selected_plan')}` : '',
        d.get('selected_service') ? `${T('wa_service', 'Service')}: ${d.get('selected_service')}` : '', '', T('wa_requirements', 'Requirements:'), d.get('requirements')
      ].filter(Boolean);
      const url = `https://wa.me/${number}?text=${encodeURIComponent(lines.join('\n'))}`;
      const win = window.open(url, '_blank', 'noopener,noreferrer');
      if (!win) window.location.href = url;
      if (note) { note.textContent = T('wa_opening', 'WhatsApp is opening with your enquiry prepared. Please review it and press Send in WhatsApp.'); note.classList.remove('is-error'); note.classList.add('is-success'); }
    });
  });
})();

(() => {
  const bar = document.querySelector('[data-portfolio-filter]');
  if (!bar) return;
  const rows = Array.from(document.querySelectorAll('.portfolio-section .category-row'));
  const chips = Array.from(bar.querySelectorAll('[data-filter]'));
  const apply = (f, push) => {
    chips.forEach(c => { const on = c.dataset.filter === f; c.classList.toggle('is-active', on); c.setAttribute('aria-pressed', String(on)); });
    rows.forEach(r => { const show = f === 'all' || r.id === f; r.hidden = !show; if (show) r.classList.add('is-visible'); });
    if (push) history.replaceState(null, '', window.location.pathname + window.location.search + (f === 'all' ? '' : '#' + f));
  };
  chips.forEach(c => c.addEventListener('click', () => {
    apply(c.dataset.filter, true);
    const top = bar.getBoundingClientRect().top + window.scrollY - 90;
    if (window.scrollY > top + 40) window.scrollTo({ top, behavior: 'smooth' });
  }));
  const fromHash = () => { const h = window.location.hash.replace('#', ''); return rows.some(r => r.id === h) ? h : 'all'; };
  apply(fromHash(), false);
  if (fromHash() !== 'all') requestAnimationFrame(() => window.scrollTo({ top: bar.getBoundingClientRect().top + window.scrollY - 90 }));
  window.addEventListener('hashchange', () => apply(fromHash(), false));
})();

/* Portfolio hero: dense dot-terrain (fine mesh, rolling swells that flow toward the viewer, reacts to touch / mouse / scroll, tap makes a ripple). */
(() => {
  const wave = document.querySelector('.showcase-wave');
  if (!wave) return;
  document.body.classList.add('page-portfolio');
  const host = wave.closest('.section-heading') || wave;
  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const canvas = document.createElement('canvas');
  canvas.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;display:block';
  const ctx = canvas.getContext('2d');
  if (!ctx) return;
  wave.appendChild(canvas);
  wave.classList.add('is-live');

  /* colours come from the theme settings (CSS variables), with safe fallbacks */
  const toRGB = (v, d) => {
    v = (v || '').trim();
    let m = /^#([0-9a-f]{6})$/i.exec(v);
    if (m) { const n = parseInt(m[1], 16); return [n >> 16, (n >> 8) & 255, n & 255]; }
    m = /^#([0-9a-f]{3})$/i.exec(v);
    if (m) return m[1].split('').map(c => parseInt(c + c, 16));
    return d;
  };
  const cs = getComputedStyle(document.documentElement);
  const LAV = toRGB(cs.getPropertyValue('--lavender'), [201, 184, 240]);
  const VIO = toRGB(cs.getPropertyValue('--violet'), [101, 80, 184]);
  const SPARK = [Math.min(255, VIO[0] + 70), Math.min(255, VIO[1] + 60), Math.min(255, VIO[2] + 80)];

  /* ---- tuning ---- */
  const TOP = 0.46;          /* where the mesh starts (share of the hero height, from the top) */
  const LEVELS = 8;          /* alpha buckets: dots are painted in a few batches, not one by one */
  const SPEED = 0.3;         /* how fast the terrain flows toward the viewer */
  const TIME = 0.32;         /* how fast the swells roll */
  const DD = 0.42, DMAX = 44, C = 0.0225;   /* row step, depth range, perspective strength */
  const PMAX = 1 / (1 + DMAX * C);

  let W = 0, H = 0, YT = 0, SPAN = 0, DX = 0, AMP = 0, DOT = 1, raf = 0, visible = true;
  const ptr = { x: -999, y: -999, tx: -999, ty: -999, s: 0, ts: 0 };
  /* follower dot (lavender): rests in the hero, glides to the finger / mouse with a lagging halo ring */
  const dot = { x: 0, y: 0, tx: 0, ty: 0, x2: 0, y2: 0, init: false };
  const dotTo = p => { dot.tx = p.x; dot.ty = p.y; };
  const ripples = [];
  const start = performance.now();
  let last = start, phase = 0, scrollY0 = window.scrollY, boost = 0;
  const styles = [];
  const mk = (c, a) => 'rgba(' + c[0] + ',' + c[1] + ',' + c[2] + ',' + a.toFixed(3) + ')';

  const resize = () => {
    const r = wave.getBoundingClientRect();
    W = r.width; H = r.height;
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    YT = H * TOP;                    /* far edge */
    SPAN = H * 1.04 - YT;            /* near edge sits just under the hero, hidden by the white sheet */
    const mobile = W < 600;
    DX = mobile ? 6.6 : 8;          /* dot spacing at the nearest row (px) */
    AMP = Math.min(24, SPAN * 0.075);  /* swell height at the nearest row (px) */
    DOT = mobile ? 0.72 : 0.85;       /* dot radius at the nearest row (px) */
    if (!dot.init) { dot.x = dot.x2 = dot.tx = W * 0.7; dot.y = dot.y2 = dot.ty = H * 0.62; dot.init = true; }
    if (reduce) draw(start);
  };
  const local = e => { const r = wave.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; };
  if (!reduce) {
    host.addEventListener('pointermove', e => { const p = local(e); dotTo(p); ptr.tx = p.x; ptr.ty = p.y; ptr.ts = 1; if (ptr.s < 0.05) { ptr.x = p.x; ptr.y = p.y; } }, { passive: true });
    host.addEventListener('pointerdown', e => {
      const p = local(e); dotTo(p);
      ptr.x = ptr.tx = p.x; ptr.y = ptr.ty = p.y; ptr.ts = 1;
      ripples.push({ x: p.x, y: p.y, t: performance.now() });
      if (ripples.length > 4) ripples.shift();
    }, { passive: true });
    const release = () => { ptr.ts = 0; };
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(n => host.addEventListener(n, release, { passive: true }));
  }

  const hash = (a, b) => { const s = Math.sin(a * 127.1 + b * 311.7) * 43758.5453; return s - Math.floor(s); };
  /* layered travelling swells; x in near-row px, D = world depth */
  const height = (x, D, t) =>
      Math.sin(x * 0.0095 + D * 0.12 + t * 0.9)
    + 0.5 * Math.sin(x * 0.014 - D * 0.16 + t * 0.7)
    + 0.25 * Math.sin(x * 0.004 + D * 0.06 - t * 0.5);

  const sm = (a, b, v) => { const k = Math.max(0, Math.min(1, (v - a) / (b - a))); return k * k * (3 - 2 * k); };

  function draw(now) {
    const dt = Math.min(0.05, (now - last) / 1000); last = now;
    const t = reduce ? 5 : (now - start) / 1000 * TIME;
    const sy = window.scrollY, dv = Math.abs(sy - scrollY0); scrollY0 = sy;
    boost += (Math.min(dv * 0.012, 0.5) - boost) * 0.04;
    if (!reduce) phase += dt * (SPEED + boost);
    ptr.x += (ptr.tx - ptr.x) * 0.25; ptr.y += (ptr.ty - ptr.y) * 0.25; ptr.s += (ptr.ts - ptr.s) * 0.12;
    const R = Math.max(90, Math.min(150, W * 0.26)), R2 = 2 * R * R * 0.45;
    for (let i = ripples.length - 1; i >= 0; i--) if (now - ripples[i].t > 1800) ripples.splice(i, 1);

    ctx.clearRect(0, 0, W, H);
    const pInt = Math.floor(phase), frac = phase - pInt;
    const rows = Math.ceil(DMAX / DD) + 2;
    /* buckets: [colour class 0 lavender / 1 white][alpha level] -> list of x,y,r */
    const buckets = [[], []];
    for (let c = 0; c < 2; c++) for (let l = 0; l < LEVELS; l++) buckets[c].push([]);
    const hot = [];  /* big / glowing dots, drawn one by one (few) */

    for (let i = 0; i < rows; i++) {
      const d = (i - frac) * DD;
      if (d < -0.3) continue;
      const dd = Math.max(0, d);
      const p = 1 / (1 + dd * C);                         /* perspective scale: 1 near … PMAX far */
            const n = i + pInt, D = (i - frac + pInt) * DD;
      const depth = (p - PMAX) / (1 - PMAX);              /* 0 far … 1 near */
      const yBase = YT + SPAN * depth;
      const topFade = sm(0, 0.5, depth) * (0.35 + 0.65 * sm(0, 0.18, depth));
      const rowA = Math.min(1, topFade * Math.min(1, (d + 0.3) / 1.2));
      if (rowA < 0.02) continue;
      const step = DX * p;
      const half = Math.ceil((W / 2 + 40) / step);
      const rad0 = DOT * (0.5 + 0.5 * p / 1);
      for (let j = -half; j <= half; j++) {
        const wx = j * DX, px0 = W / 2 + j * step;
        const h = height(wx, D, t);
        const lift = h * AMP * p;
        let px = px0, py = yBase - lift;
        const crest = Math.max(0, Math.min(1, h * 0.25 + 0.4));
        let rad = rad0 * (0.8 + 0.5 * crest);
        let a = rowA * (0.26 + 0.42 * crest);
        let mix = crest > 0.78 ? 0.5 : 0;
        let big = false;
        if (ptr.s > 0.01) {
          const dx = px - ptr.x, dy = py - ptr.y, d2 = dx * dx + dy * dy;
          const f = Math.exp(-d2 / R2) * ptr.s;
          if (f > 0.01) {
            py -= f * 26; px += dx * f * 0.1;
            rad += f * 0.9; a += f * 0.45; mix = Math.max(mix, f); big = f > 0.5;
          }
        }
        for (let m = 0; m < ripples.length; m++) {
          const rp = ripples[m], age = now - rp.t, life = 1 - age / 1800;
          const dx = px - rp.x, dy = (py - rp.y) * 1.5, dist = Math.sqrt(dx * dx + dy * dy) || 1;
          const delta = dist - age * 0.3;
          if (Math.abs(delta) < 60) {
            const f = Math.cos(delta / 60 * Math.PI / 2) * life;
            py -= f * 14; px += dx / dist * f * 5; rad += f * 0.8; a += f * 0.5; mix = Math.max(mix, f); big = big || f > 0.55;
          }
        }
        if (py < YT - 60 || py > H + 8) continue;
        const hs = hash(j, n);
        if (hs > 0.993 && rowA > 0.2) {
          const tw = 0.55 + 0.45 * Math.sin(t * 2.2 + hs * 120);
          hot.push(px, py, rad, rowA * tw, 1);
          continue;
        }
        if (a < 0.03) continue;
        if (big) { hot.push(px, py, rad, Math.min(1, a), 0); continue; }
        const lv = Math.min(LEVELS - 1, Math.floor(Math.min(1, a) * LEVELS));
        const arr = buckets[mix > 0.4 ? 1 : 0][lv];
        arr.push(px, py, rad);
      }
    }

    for (let c = 0; c < 2; c++) {
      const col = c ? [232, 228, 244] : [LAV[0] * 0.82 | 0, LAV[1] * 0.82 | 0, LAV[2] * 0.85 | 0];
      for (let l = 0; l < LEVELS; l++) {
        const arr = buckets[c][l];
        if (!arr.length) continue;
        ctx.fillStyle = mk(col, (l + 0.5) / LEVELS);
        ctx.beginPath();
        for (let k = 0; k < arr.length; k += 3) { const r = arr[k + 2]; ctx.rect(arr[k] - r, arr[k + 1] - r, r * 2, r * 2); }
        ctx.fill();
      }
    }
    for (let k = 0; k < hot.length; k += 5) {
      const x = hot[k], y = hot[k + 1], r = hot[k + 2], a = hot[k + 3], spark = hot[k + 4];
      if (spark) {
        ctx.fillStyle = mk(SPARK, a * 0.16);
        ctx.beginPath(); ctx.arc(x, y, r * 4 + 2, 0, 6.2832); ctx.fill();
        ctx.fillStyle = mk(SPARK, Math.min(1, a + 0.2));
        ctx.beginPath(); ctx.arc(x, y, r * 1.5 + 0.5, 0, 6.2832); ctx.fill();
      } else {
        ctx.fillStyle = mk([232, 228, 244], a * 0.8);
        ctx.beginPath(); ctx.arc(x, y, r, 0, 6.2832); ctx.fill();
      }
    }
    /* follower dot + halo + trailing ring */
    dot.x += (dot.tx - dot.x) * 0.2; dot.y += (dot.ty - dot.y) * 0.2;
    dot.x2 += (dot.x - dot.x2) * 0.08; dot.y2 += (dot.y - dot.y2) * 0.08;
    const idle = reduce ? 0 : 1 - ptr.s;
    const tt = (now - start) / 1000;
    const dx0 = dot.x + Math.sin(tt * 0.9) * 7 * idle, dy0 = dot.y + Math.cos(tt * 0.7) * 6 * idle;
    const dx1 = dot.x2 + Math.sin(tt * 0.9) * 7 * idle, dy1 = dot.y2 + Math.cos(tt * 0.7) * 6 * idle;
    const boostD = 0.8 + 0.2 * ptr.s;
    const halo = ctx.createRadialGradient(dx0, dy0, 0, dx0, dy0, 78);
    halo.addColorStop(0, mk(SPARK, 0.42 * boostD)); halo.addColorStop(1, mk(SPARK, 0));
    ctx.fillStyle = halo; ctx.beginPath(); ctx.arc(dx0, dy0, 78, 0, 6.2832); ctx.fill();
    ctx.strokeStyle = mk(LAV, 0.28 * boostD); ctx.lineWidth = 1;
    ctx.beginPath(); ctx.arc(dx1, dy1, 15 + 3 * ptr.s, 0, 6.2832); ctx.stroke();
    ctx.fillStyle = mk(LAV, 0.97); ctx.beginPath(); ctx.arc(dx0, dy0, 5, 0, 6.2832); ctx.fill();
  }
  const loop = now => { if (!visible) { raf = 0; return; } draw(now); raf = requestAnimationFrame(loop); };
  const play = () => { if (!raf && visible && !reduce) { last = performance.now(); raf = requestAnimationFrame(loop); } };
  resize();
  window.addEventListener('resize', resize);
  if ('IntersectionObserver' in window) new IntersectionObserver(es => { visible = es[0].isIntersecting; if (visible) play(); }, { threshold: 0 }).observe(host);
  if (reduce) draw(start); else play();
})();


/* Menu lead form: email only, posted to Shopify's native contact form (lands in the store's inbox). */
(() => {
  document.querySelectorAll('[data-nav-lead]').forEach(form => {
    const note = form.querySelector('[data-lead-note]');
    const input = form.querySelector('input[type="email"]');
    const btn = form.querySelector('button[type="submit"]');
    const say = (msg, state) => { if (note) { note.textContent = msg; note.dataset.state = state || ''; } };
    form.addEventListener('submit', async e => {
      if (!window.fetch || !window.FormData) return; /* no JS fetch: normal form post still works */
      e.preventDefault();
      if (form.classList.contains('is-sent')) return;
      if (!input.checkValidity()) { input.reportValidity(); return; }
      form.classList.add('is-sending'); say('', '');
      try {
        const res = await fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' }, credentials: 'same-origin' });
        if (res.ok && !/challenge/.test(res.url)) {
          form.classList.add('is-sent'); input.value = '';
          say(T('lead_ok', 'Thank you. We will contact you shortly.'), 'ok');
        } else if (/challenge/.test(res.url)) {
          form.submit(); /* Shopify spam check: let the browser complete it */
        } else {
          say(T('lead_err', 'Something went wrong. Please try again.'), 'error');
        }
      } catch (err) {
        say(T('lead_conn', 'Connection problem. Please try again.'), 'error');
      } finally { form.classList.remove('is-sending'); }
    });
  });
})();

/* Selected Work (home): the section melts from the site's graphite to white as you reach it, then back to graphite as you leave. */
(() => {
  const sec = document.querySelector('.portfolio-featured-section');
  if (!sec) return;
  sec.setAttribute('data-sw', '');
  const DARK = [37, 37, 45], LIGHT = [248, 247, 251];
  const INK_D = [248, 247, 251], INK_L = [28, 28, 34];
  const ACC_D = [169, 154, 231], ACC_L = [101, 80, 184];
  const mix = (a, b, t) => a.map((v, i) => Math.round(v + (b[i] - v) * t));
  const rgb = c => 'rgb(' + c[0] + ',' + c[1] + ',' + c[2] + ')';
  const sm = (a, b, v) => { const k = Math.max(0, Math.min(1, (v - a) / (b - a))); return k * k * k * (k * (k * 6 - 15) + 10); };
  let cur = -1, target = 0, raf = 0;
  const measure = () => {
    const r = sec.getBoundingClientRect(), vh = window.innerHeight || 800;
    const d = Math.abs(r.top + r.height / 2 - vh / 2);
    target = 1 - sm(vh * 0.08, (vh + r.height) / 2 * 0.82, d);
  };
  const paint = w => {
    const s = sec.style;
    s.setProperty('--sw', w.toFixed(3));
    s.setProperty('--sw-bg', rgb(mix(DARK, LIGHT, w)));
    const ink = mix(INK_D, INK_L, w);
    s.setProperty('--sw-ink', rgb(ink));
    s.setProperty('--sw-soft', 'rgba(' + ink.join(',') + ',' + (0.62 + 0.04 * w).toFixed(2) + ')');
    s.setProperty('--sw-line', 'rgba(' + ink.join(',') + ',' + (0.22 - 0.06 * w).toFixed(2) + ')');
    s.setProperty('--sw-acc', rgb(mix(ACC_D, ACC_L, w)));
    s.setProperty('--sw-r', Math.round(w * (window.innerWidth < 760 ? 34 : 64)) + 'px');
  };
  /* ease toward the scroll-derived target so colour changes feel soft, not twitchy */
  const tick = () => {
    measure();
    cur = cur < 0 ? target : cur + (target - cur) * 0.14;
    if (Math.abs(target - cur) < 0.002) cur = target;
    paint(cur);
    raf = cur === target ? 0 : requestAnimationFrame(tick);
  };
  const kick = () => { if (!raf) raf = requestAnimationFrame(tick); };
  window.addEventListener('scroll', kick, { passive: true });
  window.addEventListener('resize', kick);
  tick();
})();

/* Home hero: light-beam canvas (thin diagonal rays + glowing streaks). Bends toward finger / mouse, follower dot, tap pulse, scroll parallax. */
(() => {
  const hero = document.querySelector('.hero-cinematic') || document.querySelector('.portfolio-section--showcase .section-heading');
  const host = hero && (hero.querySelector('.cinematic-hero-ambience') || hero.querySelector('.portfolio-cinematic-ambience'));
  if (!host) return;
  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const canvas = document.createElement('canvas');
  canvas.className = 'hero-beams';
  canvas.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;display:block';
  const ctx = canvas.getContext('2d');
  if (!ctx) return;
  host.appendChild(canvas);
  hero.classList.add('has-beams');

  const toRGB = (v, d) => {
    v = (v || '').trim();
    const m = /^#([0-9a-f]{6})$/i.exec(v);
    if (m) { const n = parseInt(m[1], 16); return [n >> 16, (n >> 8) & 255, n & 255]; }
    return d;
  };
  const cs = getComputedStyle(document.documentElement);
  const LAV = toRGB(cs.getPropertyValue('--lavender'), [201, 184, 240]);
  const VIO = toRGB(cs.getPropertyValue('--violet'), [101, 80, 184]);
  const GLOW = [Math.min(255, VIO[0] + 40), Math.min(255, VIO[1] + 30), Math.min(255, VIO[2] + 60)];
  const rgba = (c, a) => 'rgba(' + c[0] + ',' + c[1] + ',' + c[2] + ',' + Math.max(0, a).toFixed(3) + ')';

  let W = 0, H = 0, raf = 0, visible = true, scrollShift = 0;
  const ptr = { x: 0, y: 0, tx: 0, ty: 0, x2: 0, y2: 0, s: 0, ts: 0, has: false, fine: false };
  const pulses = [];
  const start = performance.now();
  let last = start;
  const rnd = (() => { let s = 7; return () => (s = (s * 16807) % 2147483647) / 2147483647; })();

  /* steep thin rays and shallow glowing streaks, generated once */
  const rays = [], streaks = [];
  for (let i = 0; i < 26; i++) rays.push({ u: rnd(), ang: 1.2 + rnd() * 0.22, len: 0.55 + rnd() * 0.7, a: 0.1 + rnd() * 0.3, sp: (rnd() - 0.5) * 0.012, ph: rnd() * 6.28, hot: rnd() > 0.72 });
  for (let i = 0; i < 9; i++) streaks.push({ u: rnd(), v: 0.55 + rnd() * 0.55, ang: -(0.42 + rnd() * 0.16), len: 0.35 + rnd() * 0.5, w: 0.8 + rnd() * 2.2, a: 0.25 + rnd() * 0.5, sp: 0.01 + rnd() * 0.022, ph: rnd() * 6.28 });

  const resize = () => {
    const r = host.getBoundingClientRect();
    W = r.width; H = r.height;
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    if (!ptr.has) { ptr.x = ptr.tx = ptr.x2 = W * 0.62; ptr.y = ptr.ty = ptr.y2 = H * 0.6; }
    if (reduce) draw(start);
  };
  const local = e => { const r = host.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; };
  if (!reduce) {
    hero.addEventListener('pointermove', e => {
      const p = local(e); ptr.fine = e.pointerType === 'mouse';
      ptr.tx = p.x; ptr.ty = p.y; ptr.ts = 1;
      if (!ptr.has) { ptr.x = ptr.x2 = p.x; ptr.y = ptr.y2 = p.y; ptr.has = true; }
    }, { passive: true });
    hero.addEventListener('pointerdown', e => {
      const p = local(e); ptr.fine = e.pointerType === 'mouse';
      ptr.tx = p.x; ptr.ty = p.y; ptr.ts = 1; if (!ptr.has) { ptr.x = p.x; ptr.y = p.y; ptr.has = true; }
      pulses.push({ x: p.x, y: p.y, t: performance.now() });
      if (pulses.length > 4) pulses.shift();
    }, { passive: true });
    const release = e => { if (!ptr.fine) ptr.ts = 0; };
    ['pointerup', 'pointercancel'].forEach(n => hero.addEventListener(n, release, { passive: true }));
    hero.addEventListener('pointerleave', () => { ptr.ts = 0; }, { passive: true });
    window.addEventListener('scroll', () => { scrollShift = Math.min(1, Math.max(0, window.scrollY / (H || 1))); }, { passive: true });
  }

  function draw(now) {
    const dt = Math.min(0.05, (now - last) / 1000); last = now;
    const t = reduce ? 3 : (now - start) / 1000;
    ptr.x += (ptr.tx - ptr.x) * 0.16; ptr.y += (ptr.ty - ptr.y) * 0.16;
    ptr.s += (ptr.ts - ptr.s) * 0.1;
    for (let i = pulses.length - 1; i >= 0; i--) if (now - pulses[i].t > 1600) pulses.splice(i, 1);
    const R = Math.max(130, Math.min(240, W * 0.3));
    ctx.clearRect(0, 0, W, H);

    /* soft ring outlines (the quiet circle motif of the reference) */
    ctx.lineWidth = 1;
    ctx.strokeStyle = rgba(LAV, 0.07);
    ctx.beginPath(); ctx.arc(W * 0.16, H * 0.2, Math.min(W, H) * 0.2 + Math.sin(t * 0.3) * 4, 0, 6.2832); ctx.stroke();
    ctx.strokeStyle = rgba(LAV, 0.045);
    ctx.beginPath(); ctx.arc(W * 0.16, H * 0.2, Math.min(W, H) * 0.31, 0, 6.2832); ctx.stroke();

    ctx.globalCompositeOperation = 'lighter';

    /* thin steep rays: slow drift, bend toward the pointer, brighten near it */
    for (const r of rays) {
      const drift = ((r.u + t * r.sp + 1) % 1);
      const bx = (drift * 1.5 - 0.25) * W - scrollShift * 60 * r.len;
      const dx = Math.cos(r.ang), dy = Math.sin(r.ang);
      const L = H * 1.35 * r.len;
      const x0 = bx - dx * L * 0.35, y0 = -H * 0.1 - dy * L * 0.0;
      const x1 = x0 + dx * L * 0.7 * -1, y1 = y0 + dy * L;
      const g = ctx.createLinearGradient(x0, y0, x1, y1);
      const pulse = 0.75 + 0.25 * Math.sin(t * 0.6 + r.ph);
      const col = r.hot ? LAV : GLOW;
      g.addColorStop(0, rgba(col, 0)); g.addColorStop(0.3, rgba(col, r.a * 0.55 * pulse)); g.addColorStop(0.7, rgba(col, r.a * 0.25 * pulse)); g.addColorStop(1, rgba(col, 0));
      ctx.strokeStyle = g; ctx.lineWidth = r.hot ? 1.1 : 0.8;
      ctx.beginPath();
      const N = 22;
      for (let k = 0; k <= N; k++) {
        const s = k / N;
        let px = x0 + (x1 - x0) * s, py = y0 + (y1 - y0) * s;
        if (ptr.s > 0.01) {
          const ddx = ptr.x - px, ddy = ptr.y - py, d2 = ddx * ddx + ddy * ddy;
          const f = Math.exp(-d2 / (2 * R * R * 0.5)) * ptr.s;
          px += ddx * f * 0.34; py += ddy * f * 0.12;
        }
        k ? ctx.lineTo(px, py) : ctx.moveTo(px, py);
      }
      ctx.stroke();
    }

    /* glowing streaks: sliding light sweeps in the lower right, bloom layers */
    for (const s of streaks) {
      const slide = (t * s.sp + s.ph) % 1;
      const cx = W * (0.35 + s.u * 0.95) + (slide - 0.5) * W * 0.28 + (ptr.x / (W || 1) - 0.5) * 22 - scrollShift * 40;
      const cy = H * (0.4 + s.v * 0.42) - (slide - 0.5) * H * 0.1;
      const L = Math.max(W, H * 0.8) * s.len, dx = Math.cos(s.ang), dy = Math.sin(s.ang);
      const x0 = cx - dx * L * 0.5, y0 = cy - dy * L * 0.5, x1 = cx + dx * L * 0.5, y1 = cy + dy * L * 0.5;
      let boost = 0;
      if (ptr.s > 0.01) { const ddx = ptr.x - cx, ddy = ptr.y - cy; boost = Math.exp(-(ddx * ddx + ddy * ddy) / (2 * R * R * 2.2)) * ptr.s; }
      const breathe = 0.7 + 0.3 * Math.sin(t * 0.5 + s.ph * 5);
      const a = s.a * breathe * (1 + boost * 1.6);
      const g = ctx.createLinearGradient(x0, y0, x1, y1);
      g.addColorStop(0, rgba(GLOW, 0)); g.addColorStop(0.45, rgba(GLOW, a * 0.55)); g.addColorStop(0.85, rgba(LAV, a)); g.addColorStop(1, rgba(LAV, 0));
      ctx.lineCap = 'round'; ctx.strokeStyle = g;
      ctx.globalAlpha = 0.16; ctx.lineWidth = s.w * 12; ctx.beginPath(); ctx.moveTo(x0, y0); ctx.lineTo(x1, y1); ctx.stroke();
      ctx.globalAlpha = 0.32; ctx.lineWidth = s.w * 4; ctx.beginPath(); ctx.moveTo(x0, y0); ctx.lineTo(x1, y1); ctx.stroke();
      ctx.globalAlpha = 1; ctx.lineWidth = Math.max(0.8, s.w * 0.6); ctx.beginPath(); ctx.moveTo(x0, y0); ctx.lineTo(x1, y1); ctx.stroke();
    }

    /* tap pulse rings */
    for (const p of pulses) {
      const age = Math.max(0, Math.min(1, (now - p.t) / 1600)), rad = age * Math.max(180, W * 0.45);
      ctx.strokeStyle = rgba(LAV, (1 - age) * 0.45); ctx.lineWidth = 1.2;
      ctx.beginPath(); ctx.arc(p.x, p.y, rad, 0, 6.2832); ctx.stroke();
      ctx.strokeStyle = rgba(GLOW, (1 - age) * 0.25);
      ctx.beginPath(); ctx.arc(p.x, p.y, rad * 0.62, 0, 6.2832); ctx.stroke();
    }

    /* follower dot + halo (the little red dot of the reference, in the theme's lavender) */
    {
      const idle = reduce ? 0 : 1 - ptr.s;
      ptr.x2 += (ptr.x - ptr.x2) * 0.07; ptr.y2 += (ptr.y - ptr.y2) * 0.07;
      const fx = ptr.x + Math.sin(t * 0.9) * 7 * idle, fy = ptr.y + Math.cos(t * 0.7) * 6 * idle;
      const gx = ptr.x2 + Math.sin(t * 0.9) * 7 * idle, gy = ptr.y2 + Math.cos(t * 0.7) * 6 * idle;
      const da = 0.8 + 0.2 * ptr.s;
      const halo = ctx.createRadialGradient(fx, fy, 0, fx, fy, 78);
      halo.addColorStop(0, rgba(GLOW, 0.42 * da)); halo.addColorStop(1, rgba(GLOW, 0));
      ctx.fillStyle = halo; ctx.beginPath(); ctx.arc(fx, fy, 78, 0, 6.2832); ctx.fill();
      ctx.globalCompositeOperation = 'source-over';
      ctx.strokeStyle = rgba(LAV, 0.28 * da); ctx.lineWidth = 1;
      ctx.beginPath(); ctx.arc(gx, gy, 15 + 3 * ptr.s, 0, 6.2832); ctx.stroke();
      ctx.fillStyle = rgba(LAV, 0.97); ctx.beginPath(); ctx.arc(fx, fy, 5, 0, 6.2832); ctx.fill();
    }
    ctx.globalCompositeOperation = 'source-over'; ctx.globalAlpha = 1;
  }
  const loop = now => { if (!visible) { raf = 0; return; } draw(now); raf = requestAnimationFrame(loop); };
  const play = () => { if (!raf && visible && !reduce) { last = performance.now(); raf = requestAnimationFrame(loop); } };
  resize();
  window.addEventListener('resize', resize);
  if ('IntersectionObserver' in window) new IntersectionObserver(es => { visible = es[0].isIntersecting; if (visible) play(); }, { threshold: 0 }).observe(hero);
  if (reduce) draw(start); else play();
})();

/* ===== Page transition (curtain wipe) ===== */
(() => {
  const KEY = 'teyra-pt';
  const root = document.documentElement;
  const wrap = document.querySelector('[data-page-transition]');
  if (!wrap || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !wrap.animate) { root.classList.remove('pt-covering'); return; }
  const curtain = wrap.querySelector('.pt-curtain');
  const labelEl = wrap.querySelector('[data-pt-label]');
  const EASE = 'cubic-bezier(.76,0,.24,1)';
  const OFF = '16vh';
  const reset = () => {
    root.classList.remove('pt-covering');
    wrap.classList.remove('is-active');
    curtain.classList.remove('is-out');
    curtain.getAnimations().forEach(a => a.cancel());
    labelEl.getAnimations().forEach(a => a.cancel());
  };
  const T = window.teyraT;
  const labels = { '#studio': T('nav_studio', 'The Studio'), '#services': T('nav_services', 'Services'), '#maintenance': T('nav_maintenance', 'Maintenance'), '#contact': T('nav_contact', 'Contact') };
  const pretty = s => s.replace(/[-_]+/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  const getLabel = (url, a) => {
    if (labels[url.hash]) return labels[url.hash];
    /* opening a project (?project=...) or coming back from one => Portfolio */
    if (url.searchParams.has('project') || new URLSearchParams(location.search).has('project')) return T('nav_portfolio', 'Portfolio');
    const path = url.pathname.replace(/\/+$/, '');
    if (!path || path === '' || /^\/[a-z]{2}(-[A-Z]{2})?$/.test(path)) return T('nav_home', 'Home');
    if (/\/pages\/portfolio$/.test(path)) return T('nav_portfolio', 'Portfolio');
    const txt = (a.getAttribute('aria-label') || a.textContent || '').replace(/\s+/g, ' ').trim();
    if (txt && txt.length <= 26) return txt.replace(/[→↗↘>›»]+\s*$/, '').trim();
    return pretty(path.split('/').filter(Boolean).pop() || T('nav_home', 'Home'));
  };
  const goIn = (label, go) => {
    labelEl.textContent = label;
    wrap.classList.add('is-active');
    curtain.classList.remove('is-out');
    const slide = curtain.animate(
      [{ transform: `translateY(calc(100% + ${OFF}))` }, { transform: 'translateY(0)' }],
      { duration: 700, easing: EASE, fill: 'forwards' });
    slide.onfinish = () => {
      labelEl.animate([{ transform: 'translateY(115%)' }, { transform: 'translateY(0)' }],
        { duration: 550, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'forwards' });
      setTimeout(go, 750);
    };
  };
  const goOut = () => {
    labelEl.animate([{ transform: 'translateY(0)' }, { transform: 'translateY(-115%)' }],
      { duration: 450, easing: EASE, fill: 'forwards' });
    setTimeout(() => {
      curtain.classList.add('is-out');
      const up = curtain.animate(
        [{ transform: 'translateY(0)' }, { transform: `translateY(calc(-100% - ${OFF}))` }],
        { duration: 800, easing: EASE, fill: 'forwards' });
      up.onfinish = reset;
    }, 280);
  };
  if (root.classList.contains('pt-covering')) {
    try { sessionStorage.removeItem(KEY); } catch (e) {}
    let done = false;
    const start = () => { if (done) return; done = true; setTimeout(goOut, 120); };
    if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
    setTimeout(start, 2500);
  }
  window.addEventListener('pageshow', e => { if (e.persisted) reset(); });
  document.addEventListener('click', e => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target.closest && e.target.closest('a[href]');
    if (!a || a.target === '_blank' || a.hasAttribute('download') || a.hasAttribute('data-no-transition')) return;
    const raw = a.getAttribute('href');
    if (!raw || /^(mailto:|tel:|javascript:)/i.test(raw)) return;
    let url; try { url = new URL(a.href, location.href); } catch (err) { return; }
    if (url.origin !== location.origin) return;
    if (/\/(cart|checkout)/.test(url.pathname)) return;
    const samePage = url.pathname === location.pathname && url.search === location.search;
    if (samePage) {
      /* same-page menu anchors (The Studio, Services, Maintenance, Contact): curtain, jump under cover, reveal */
      const target = url.hash && labels[url.hash] ? document.querySelector(url.hash) : null;
      if (!target) return; // other anchors: normal smooth scroll
      e.preventDefault();
      goIn(labels[url.hash], () => {
        root.style.scrollBehavior = 'auto';
        target.scrollIntoView({ behavior: 'auto', block: 'start' });
        history.replaceState(null, '', url.hash);
        requestAnimationFrame(() => { root.style.scrollBehavior = ''; goOut(); });
      });
      return;
    }
    e.preventDefault();
    const label = getLabel(url, a);
    try { sessionStorage.setItem(KEY, label); } catch (err) {}
    goIn(label, () => { location.href = url.href; });
  });
})();


/* TEYRA cinematic scroll choreography: reveals copy and photos in sequence. */
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const mobile = window.matchMedia('(max-width: 760px)').matches;

  const sections = Array.from(document.querySelectorAll(
    '.shopify-section > section, main > section, .portfolio-sheet'
  )).filter(section =>
    /* Selected Work has its own scroll-driven colour transition. Keep it out of the
       generic reveal/depth choreography so the carousel never inherits a vertical
       translate from the section reveal while the user scrolls. */
    !section.matches('[data-cinematic-home], .hero, .portfolio-featured-section, .site-footer, footer') &&
    !section.closest('.site-header, .site-footer, footer')
  );

  if (!reduced && 'IntersectionObserver' in window) {
    const sectionObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('scroll-emotion-visible');
          sectionObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });

    sections.forEach(section => {
      section.setAttribute('data-scroll-emotion', '');
      const candidates = section.querySelectorAll(
        '.section-heading, .intro-strip-inner, .service-card, .service-row, .maintenance-card, ' +
        '.category-heading, .project-card, .project-detail, .contact-grid, .contact-copy, ' +
        '.contact-form, .selected-work-toolbar, .selected-work-footer, .project-image-wrap, ' +
        '.project-visual, .project-copy, .narrow-copy, .rte, .process-step, .client-access-card'
      );
      const wrapChildren = section.querySelectorAll('.wrap > *');
      const motionTargets = Array.from(new Set([...candidates, ...wrapChildren])).filter(el =>
        !el.matches('.cinematic-hero-ambience, .portfolio-cinematic-ambience, .hero-video-wrap') &&
        !el.closest('.site-header, .site-footer, footer')
      );
      motionTargets.forEach((el, index) => {
        el.classList.add('scroll-emotion-item');
        el.style.transitionDelay = `${Math.min(index % 5, 4) * 65}ms`;
      });

      const photos = section.querySelectorAll(
        '.project-card img, .selected-work-visual-image, .project-image-wrap img, ' +
        '.project-detail img, .project-visual img, .hero-gallery img, .portfolio-image img'
      );
      photos.forEach(img => {
        img.classList.add('scroll-emotion-photo');
        const wrap = img.parentElement;
        if (wrap && wrap.classList.contains('project-image-wrap')) {
          wrap.classList.add('scroll-emotion-photo-wrap');
        }
      });
      sectionObserver.observe(section);
    });
  } else {
    sections.forEach(section => section.classList.add('scroll-emotion-visible'));
  }

  // Continuous, restrained depth while scrolling: images move more slowly than copy.
  if (!reduced) {
    let raf = 0;
    const updateDepth = () => {
      const vh = window.innerHeight || 800;
      sections.forEach(section => {
        if (!section.classList.contains('scroll-emotion-visible')) return;
        const rect = section.getBoundingClientRect();
        if (rect.bottom < -vh * .25 || rect.top > vh * 1.25) return;
        const progress = (vh * .5 - (rect.top + rect.height * .5)) / Math.max(vh + rect.height, 1);
        const shift = Math.max(-12, Math.min(12, progress * (mobile ? 18 : 26)));
        section.querySelectorAll('.scroll-emotion-photo').forEach(img => {
          img.style.setProperty('--scroll-photo-shift', `${shift}px`);
          img.style.translate = `0 ${shift}px`;
        });
      });
      raf = 0;
    };
    const requestDepth = () => { if (!raf) raf = window.requestAnimationFrame(updateDepth); };
    window.addEventListener('scroll', requestDepth, { passive: true });
    window.addEventListener('resize', requestDepth, { passive: true });
    requestDepth();
  }

  // The navigation sheet uses the same deliberate, staged entrance on every page.
  const nav = document.querySelector('[data-main-nav]');
  const toggle = document.querySelector('[data-menu-toggle]');
  if (nav && toggle) {
    toggle.addEventListener('click', () => {
      const willOpen = toggle.getAttribute('aria-expanded') === 'true';
      nav.classList.toggle('is-open', willOpen);
      if (willOpen) {
        nav.querySelectorAll('a, summary').forEach((el, index) => {
          el.style.transitionDelay = `${Math.min(index, 8) * 45}ms`;
        });
      } else {
        nav.querySelectorAll('a, summary').forEach(el => { el.style.transitionDelay = ''; });
      }
    });
  }
})();


/* TEYRA portfolio cards: cinematic reveal repeats in both scroll directions. */
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* Only animate archive/portfolio cards. The home Selected Work cards live
     inside a horizontal scroller; vertical reveal transforms are clipped by
     the scroller on mobile and make the card tops appear cut off. */
  const cards = Array.from(document.querySelectorAll(
    '.portfolio-section:not(.portfolio-featured-section) .project-card'
  ));
  if (!cards.length) return;

  if (reduced || !('IntersectionObserver' in window)) {
    cards.forEach(card => card.classList.add('portfolio-scroll-in-view'));
    return;
  }

  const cardObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const card = entry.target;
      if (entry.isIntersecting) {
        card.classList.add('portfolio-scroll-in-view');
      } else {
        // Reset on exit so the same entrance plays again when the visitor scrolls back.
        card.classList.remove('portfolio-scroll-in-view');
      }
    });
  }, {
    threshold: 0.14,
    rootMargin: '-7% 0px -9% 0px'
  });

  cards.forEach((card, index) => {
    card.classList.add('portfolio-scroll-motion');
    card.style.setProperty('--portfolio-stagger', `${Math.min(index % 3, 2) * 90}ms`);
    cardObserver.observe(card);
  });
})();


/* ===== Video showcase: load YouTube/Vimeo only when the visitor taps play ===== */
(() => {
  document.addEventListener('click', e => {
    const btn = e.target.closest && e.target.closest('[data-video-play]');
    if (!btn) return;
    const frame = document.createElement('iframe');
    frame.src = btn.dataset.embed;
    frame.className = 'video-card-iframe';
    frame.title = btn.getAttribute('aria-label') || 'Video';
    frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    frame.allowFullscreen = true;
    btn.replaceWith(frame);
  });
})();


/* Luxe project video: play overlay (works for HTML injected from <template>) */
(() => {
  const stageOf = el => el.closest('[data-pv]');
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-pv-play]');
    if (!btn) return;
    const stage = stageOf(btn);
    const video = stage && stage.querySelector('video');
    if (!video) return;
    stage.classList.add('is-playing');
    video.muted = false;
    const p = video.play();
    if (p && p.catch) p.catch(() => { video.controls = true; });
  });
  document.addEventListener('ended', e => {
    const video = e.target;
    if (!(video instanceof HTMLVideoElement)) return;
    const stage = stageOf(video);
    if (stage) { stage.classList.remove('is-playing'); video.currentTime = 0; }
  }, true);
})();

/* Theme editor: project page is built by JS, so reload it after a setting change */
document.addEventListener('shopify:section:load', () => {
  if (new URLSearchParams(window.location.search).get('project')) window.location.reload();
});


/* v21 — Selected Work: active-card focus (centre card) */
(() => {
  const track = document.querySelector('[data-selected-work-track]');
  if (!track) return;
  const cards = Array.from(track.querySelectorAll('.selected-work-card'));
  if (!cards.length) return;
  let raf = 0, current = null;
  const update = () => {
    raf = 0;
    const tr = track.getBoundingClientRect();
    const atStart = track.scrollLeft < 8;
    const atEnd = track.scrollLeft > track.scrollWidth - track.clientWidth - 8;
    let best = null, bestDist = Infinity;
    if (atStart) best = cards[0];
    else if (atEnd) best = cards[cards.length - 1];
    else {
      const mid = tr.left + tr.width / 2;
      cards.forEach(c => {
        const r = c.getBoundingClientRect();
        const d = Math.abs(r.left + r.width / 2 - mid);
        if (d < bestDist) { bestDist = d; best = c; }
      });
    }
    if (best && best !== current) {
      current && current.classList.remove('is-active');
      best.classList.add('is-active');
      current = best;
    }
  };
  const req = () => { if (!raf) raf = requestAnimationFrame(update); };
  track.addEventListener('scroll', req, { passive: true });
  window.addEventListener('resize', req, { passive: true });
  update();
})();

/* v21 — Header pill: hide on scroll down, show on scroll up */
(() => {
  const header = document.querySelector('[data-site-header]');
  if (!header) return;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;
  let last = window.scrollY, ticking = false;
  const run = () => {
    ticking = false;
    const y = window.scrollY, dy = y - last;
    const menuOpen = !!document.querySelector('.main-nav.is-open') || document.querySelector('[data-menu-toggle][aria-expanded="true"]');
    if (menuOpen || y < 140) header.classList.remove('is-hidden');
    else if (dy > 6) header.classList.add('is-hidden');
    else if (dy < -6) header.classList.remove('is-hidden');
    if (Math.abs(dy) > 6) last = y;
  };
  window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true });
})();
